module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dontHaveAccount":"Don\u0027t have an account?","email":"Email","login":"Log In","loginError":"Incorrect login or password!","password":"Password","signup":"Sign up"},"fr":{"dontHaveAccount":"Pas de compte ?","email":"Courriel","login":"Connexion au compte","loginError":"Incorrect login or password!","password":"Mot de passe","signup":"Créer un compte"}}')
  delete Component.options._Ctor
}
